import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const ToggleTableButton = styled(Button)`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.grey[50]};
  padding: ${({ theme }) => theme.spacing(1.5)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.text.primary};
`

export const TableContainer = styled('div')`
  overflow-x: auto;

  table {
    width: 100%;
    min-width: max-content;
  }
`
